module.exports = __webpack_public_path__ + "static/media/dani_close.7b7ee6c8.svg";